import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ProgramMember } from './models';

export interface LoadingStatus {
    serverRequestInProgress: boolean;
    loaded: boolean;
}

export interface State extends EntityState<ProgramMember>, LoadingStatus {}

export const adapter: EntityAdapter<ProgramMember> = createEntityAdapter<ProgramMember>();

export const initialState: State = adapter.getInitialState({
    serverRequestInProgress: false,
    loaded: false,
});
